<template>
  <div id="subscription-list">
    <!-- Subscription Cards -->
    <div class="flex flex-wrap gap-8">
      <template v-if="subscriptionRecords && subscriptionRecords.length">
        <div
          class="bg-white border border-gray-300 rounded-xl shadow-md flex flex-col transition-shadow duration-300"
          v-for="subscription in subscriptionRecords"
          :key="subscription._id"
          style="width: 31%"
        >
          <!-- Card Header -->
          <div class="p-6 border-b border-gray-300 flex justify-between items-center">
            <h3 class="text-2xl font-semibold text-gray-800">Subscription</h3>
            <span
              :class="[
                'px-4 py-2 rounded-full text-white text-sm uppercase font-semibold',
                {
                  'bg-success': subscription.status.toLowerCase() === 'active',
                  'bg-warning': subscription.status.toLowerCase() === 'pending',
                  'bg-primary': subscription.status.toLowerCase() === 'completed'
                }
              ]"
            >
              {{ subscription.status }}
            </span>
          </div>

          <!-- Card Body -->
          <div class="p-6 flex-grow space-y-4">
            <p class="text-lg text-gray-700"><strong>Order ID:</strong> {{ subscription.order_id }}</p>
            <p class="text-lg text-gray-700"><strong>Amount:</strong> {{ subscription.amount / 100 }} {{ subscription.currency }}</p>
            <p class="text-lg text-gray-700"><strong>Period:</strong> {{ subscription.period }}</p>
            <p class="text-lg text-gray-700"><strong>Start Date:</strong> {{ formatDate(subscription.start_at) }}</p>
            <p class="text-lg text-gray-700"><strong>End Date:</strong> {{ formatDate(subscription.end_at) }}</p>
            <p class="text-lg text-gray-700"><strong>Type:</strong> {{ subscription.type }}</p>
            <p v-if="subscription.purchased_by" class="text-lg text-gray-700">
              <strong>Purchased By:</strong>
              {{ subscription.purchased_by.first_name }} {{ subscription.purchased_by.last_name }}
            </p>
          </div>
        </div>
      </template>
      <!-- No Subscriptions Found Message -->
      <div v-else class="w-full text-xl">No subscription found</div>
    </div>

    <!-- Pagination Controls -->
    <div class="mt-12 flex justify-center">
      <vs-pagination v-if="subscriptionFilteredCount" v-model="page" :total="totalPages" :max="Math.min(Math.ceil(totalPages / length), 7)" class="mt-4"></vs-pagination>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'UserView',

  /** Data */
  data: () => ({
    breadcrumb: [],
    length: 9,
    page: 1,
    module_name: 'User'
  }),

  /** Computed */
  computed: {
    ...mapState('user', ['subscriptionRecords', 'subscriptionTotal', 'subscriptionFilteredCount', 'subscriptionListLoading', 'subscriptionUserDetail']),
    totalPages() {
      return Math.ceil(this.subscriptionFilteredCount / this.length)
    }
  },

  /** Methods */
  methods: {
    ...mapActions('user', {
      fetchSubscriptionList: 'subscriptionList'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** User Subscription List API */
    async getData() {
      const params = {
        limit: this.length,
        page: this.page,
        user: this.$route.params.id
      }
      await this.fetchSubscriptionList(params)
    },

    /** Format Date */
    formatDate(date) {
      return date ? moment(date).format('MMMM Do YYYY, h:mm:ss a') : '-'
    }
  },

  /** Watchers */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    subscriptionListLoading() {
      if (this.subscriptionListLoading) {
        this.$vs.loading({
          container: '#subscription-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#subscription-list > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    },
    length() {
      this.getData()
    }
  },

  /** On Rendering */
  async created() {
    await this.getData()
    /** breadcrumb implement  */
    this.breadcrumb = [
      { title: 'Dashboard', url: '/dashboard' },
      { title: 'User', url: '/user/list' },
      { title: `${this.subscriptionUserDetail.first_name} ${this.subscriptionUserDetail.last_name}`, active: true }
    ]
  }
}
</script>
